//Radiogroup
function Radio(elements, ref) {
	this.ref = ref;
	this.elements = {};
	this.elements['_0'] = elements[0];
	for(var i = 0; i < elements.length; i++) {
		this.elements[elements[i].parentNode.getElementsByTagName('label')[0].innerHTML] = elements[i];
	}
}
Radio.prototype.val = function() {
	for(var key in this.elements) {
		if(this.elements.hasOwnProperty(key) && this.elements[key].checked) {
			return this.elements[key].parentNode.getElementsByTagName('label')[0].innerHTML;
		}
	}
	return null;
}
//Select
function Select(element, ref) {
	this.element = element;
	this.ref = ref;
}
Select.prototype.val = function() {
	return this.element.options[this.element.selectedIndex].innerHTML;
}
//Checkboxes
function Check(elements, ref) {
	this.ref = ref;
	this.elements = {};
	this.elements['_0'] = elements[0];
	for(var i = 0; i < elements.length; i++) {
		this.elements[elements[i].parentNode.getElementsByTagName('label')[0].innerHTML] = elements[i];
	}
}
Check.prototype.checked = function(val) {
	if(this.elements.hasOwnProperty(val) && this.elements[val].checked) {
		return true;
	}
	return false;
}
//Other
function QuestionElement(element, ref) {
	this.element = element;
	this.ref = ref;
}
QuestionElement.prototype.val = function() {
	return this.element.val();
}

export {Radio, QuestionElement, Select, Check};



// WEBPACK FOOTER //
// ./src/js/questionnaire-helper.js